<template>
    <Popout
        trigger="mouseenter"
        placement="top"
        :border-radius="28"
        max-width="60rem"
        :offset="[0, 12]"
        :z-index="2147483647"
        style="display: inline-flex"
    >
        <slot></slot>
        <!-- Popout -->
        <template v-slot:content>
            <div class="popout-inner-container">
                <div v-if="!adgroup && !campaign" class="nested-pills">
                    <EntityPill type="account-level" content="Account Level" :tooltip="false" />
                    <!-- small up arrow icon -->
                    <div class="icon-container">
                        <svg
                            width="8"
                            height="10"
                            viewBox="0 0 8 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M4 9V1M4 1L1 4M4 1L7 4"
                                stroke="#CACAD3"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </div>
                    <Spacer height="0.75rem" />
                </div>
                <div v-if="campaign" class="nested-pills">
                    <EntityPill type="campaign" :content="campaign" :tooltip="false" />
                    <!-- small up arrow icon -->
                    <div class="icon-container">
                        <svg
                            width="8"
                            height="10"
                            viewBox="0 0 8 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M4 9V1M4 1L1 4M4 1L7 4"
                                stroke="#CACAD3"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </div>
                    <Spacer height="0.75rem" />
                </div>
                <div v-if="adgroup" class="nested-pills">
                    <EntityPill type="adgroup" :content="adgroup" :tooltip="false" />
                    <!-- small up arrow icon -->
                    <div class="icon-container">
                        <svg
                            width="8"
                            height="10"
                            viewBox="0 0 8 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M4 9V1M4 1L1 4M4 1L7 4"
                                stroke="#CACAD3"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </div>
                    <Spacer height="0.75rem" />
                </div>
                <EntityPill :type="entityType" :content="entityName" />
            </div>
        </template>
    </Popout>
</template>

<script lang="ts" setup>
import { Spacer, Popout, InfoIcon, EntityPill } from '@opteo/components-next'

const props = defineProps<{
    entityName: string
    entityType: string
    adgroup: string
    campaign: string
}>()
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
@import '@/assets/css/variables.scss';

.cell {
    @include flex;
    @include items-center;
    max-width: 14rem;
}
.popout-inner-container {
    @include ma-16;
    @include flex;
    flex-direction: column;
    @include items-center;
}
.nested-pills {
    @include relative;
    & .icon-container {
        @include absolute;
        bottom: -4px;
        left: 50%;
        transform: translateX(-50%);
        @include container;
        @include flex-center;
        width: 20px;
        height: 20px;
        @include z-max;
    }
}
</style>
